// Module
var code = "<div class=\"block-4__image image\"></div> <template id=\"block-4__quote-template\"> <div class=\"block-4__quote quote\"></div> </template> ";
// Exports
export default code;